import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import Tooltip from 'ui-library/bs/Tooltip';
import {BLUE} from 'ui-library/Colors';
import ClickableIcon, {ClickableIconStyle} from 'ui-library/icons/ClickableIcon';
import {ElementMouseEvent} from 'util/Types';

export default function AddStepButton(props: {
  onAddButtonClicked: (e: ElementMouseEvent) => void;
  disabled?: boolean;
  tooltip?: string;
}): JSX.Element {
  const {onAddButtonClicked, disabled, tooltip} = props;
  const component = (
    <ClickableIcon
      icon="plus"
      iconStyle={ClickableIconStyle.POSITIVE}
      className={css(!disabled && styles.buttonHover)}
      onClick={onAddButtonClicked}
      {...getTestProps({component: 'AddStepButton', element: 'clickableIcon'})}
      disabled={disabled}
    />
  );
  return tooltip ? <Tooltip title={tooltip}>{component}</Tooltip> : component;
}

const styles = StyleSheet.create({
  buttonHover: {
    // The at-rest color is set by ClickableIconStyle.POSITIVE
    ':hover': {
      color: BLUE,
    },
  },
});
